var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useMemo, useState } from "react";
import styled from "styled-components";
import { Line } from "react-chartjs-2";
import moment from "moment";
import colors from "../../designSystem/colors";
import { SecondaryText } from "../../designSystem";
var PerformanceChartContainer = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: ", ";\n  left: 0;\n  right: 0;\n  width: 100%;\n"], ["\n  position: ", ";\n  left: 0;\n  right: 0;\n  width: 100%;\n"])), function (props) { return (props.earn ? "absolute" : "relative"); });
var ExtrasContainer = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  padding-left: ", "px;\n  padding-right: ", "px;\n"], ["\n  padding-left: ", "px;\n  padding-right: ", "px;\n"])), function (props) { return (props.earn ? 16 : 0); }, function (props) { return (props.earn ? 16 : 0); });
var PerformanceChart = function (_a) {
    var dataset = _a.dataset, labels = _a.labels, extras = _a.extras, onChartHover = _a.onChartHover, _b = _a.themeColor, themeColor = _b === void 0 ? colors.green : _b, lineDecayAfterPointIndex = _a.lineDecayAfterPointIndex, earn = _a.earn;
    var _c = useState(null), date = _c[0], setDate = _c[1];
    var _d = useState(0), datePosition = _d[0], setDatePosition = _d[1];
    var _e = useState(0), index = _e[0], setIndex = _e[1];
    var dateStr = moment(date || new Date()).format("ddd, MMMM Do");
    var handleChartHover = useCallback(function (hoverInfo) {
        if (hoverInfo.focused) {
            setDate(hoverInfo.xData);
            setDatePosition(hoverInfo.xPosition);
            setIndex(hoverInfo.index);
        }
        else {
            setDate(null);
            setDatePosition(0);
            setIndex(0);
        }
        onChartHover && onChartHover(hoverInfo);
    }, [onChartHover]);
    var chart = useMemo(function () { return (_jsx(Chart, { dataset: dataset, labels: labels, lineDecayAfterPointIndex: lineDecayAfterPointIndex, onHover: handleChartHover, borderColor: themeColor, gradientStartColor: themeColor + "3D", gradientStopColor: themeColor + "00", pointBackgroundColor: themeColor }, void 0)); }, [dataset, labels, handleChartHover, themeColor, lineDecayAfterPointIndex]);
    var dateTooltipPosition = datePosition - 15;
    if (index === 0) {
        dateTooltipPosition = datePosition;
    }
    else if (index + 1 > dataset.length - dataset.length * 0.15) {
        dateTooltipPosition =
            datePosition -
                110 * (1 - (dataset.length - (index + 1)) / (dataset.length * 0.15));
    }
    return (_jsxs(PerformanceChartContainer, __assign({ earn: earn }, { children: [_jsx(ExtrasContainer, __assign({ earn: earn }, { children: extras }), void 0), _jsx("div", __assign({ style: {
                    position: "relative",
                    height: "240px",
                    width: "100%",
                } }, { children: chart }), void 0), date !== null ? (_jsx(SecondaryText, __assign({ fontSize: 12, lineHeight: 16, className: "position-absolute", style: {
                    whiteSpace: "nowrap",
                    left: dateTooltipPosition,
                } }, { children: dateStr }), void 0)) : undefined] }), void 0));
};
export var Chart = function (_a) {
    var dataset = _a.dataset, labels = _a.labels, onHover = _a.onHover, _b = _a.borderColor, borderColor = _b === void 0 ? colors.green : _b, _c = _a.decayedPointBorderColor, decayedPointBorderColor = _c === void 0 ? colors.green + "1F" : _c, _d = _a.decayedBorderColor, decayedBorderColor = _d === void 0 ? colors.green + "3D" : _d, _e = _a.gradientStartColor, gradientStartColor = _e === void 0 ? colors.green + "3D" : _e, _f = _a.gradientStopColor, gradientStopColor = _f === void 0 ? colors.green + "00" : _f, _g = _a.pointBackgroundColor, pointBackgroundColor = _g === void 0 ? colors.green : _g, lineDecayAfterPointIndex = _a.lineDecayAfterPointIndex, maxGridLines = _a.maxGridLines, _h = _a.padding, padding = _h === void 0 ? { top: 20, bottom: 20 } : _h, _j = _a.hoverable, hoverable = _j === void 0 ? true : _j;
    var options = useMemo(function () {
        return {
            maintainAspectRatio: false,
            title: { display: false },
            legend: { display: false },
            layout: { padding: padding },
            scales: {
                yAxes: [{ display: false }],
                xAxes: [
                    {
                        display: !!maxGridLines,
                        gridLines: {
                            drawBorder: false,
                            borderDash: [4, 4],
                            zeroLineBorderDash: [4, 4],
                            color: "#FFFFFF29",
                            zeroLineColor: "#FFFFFF29",
                        },
                        ticks: {
                            callback: function (value, index, values) {
                                return moment(values[index])
                                    .format("DD MMM YYYY")
                                    .toUpperCase();
                            },
                            maxRotation: 0,
                            maxTicksLimit: maxGridLines,
                        },
                    },
                ],
            },
            animation: { duration: 0 },
            hover: { animationDuration: 0, intersect: false },
            tooltips: {
                enabled: false,
                intersect: false,
                mode: "nearest",
            },
            onHover: function (_, elements) {
                if (elements && elements.length && hoverable) {
                    var chartElem = elements[0];
                    var chart = chartElem._chart;
                    var ctx = chart.ctx;
                    var chartIndex = chartElem._index;
                    // draw line behind dot
                    ctx.globalCompositeOperation = "destination-over";
                    var x = chartElem._view.x;
                    var topY = chart.scales["y-axis-0"].top;
                    var bottomY = chart.scales["y-axis-0"].bottom;
                    ctx.save();
                    ctx.beginPath();
                    ctx.setLineDash([5, 5]);
                    ctx.moveTo(x, topY);
                    ctx.lineTo(x, bottomY);
                    ctx.lineWidth = 1;
                    ctx.strokeStyle = "#ffffff";
                    ctx.stroke();
                    ctx.restore();
                    // now we have to revert to the dot drawing above everything
                    ctx.globalCompositeOperation = "source-over";
                    if (onHover) {
                        onHover({
                            focused: true,
                            xData: labels[chartIndex],
                            yData: dataset[chartIndex],
                            xPosition: x,
                            index: chartIndex,
                        });
                    }
                }
                else {
                    if (onHover) {
                        onHover({ focused: false });
                    }
                }
            },
        };
    }, [dataset, labels, hoverable, padding, onHover, maxGridLines]);
    var getData = useCallback(function (canvas) {
        var ctx = canvas.getContext("2d");
        var gradient = ctx.createLinearGradient(0, 0, 0, 250);
        gradient.addColorStop(0, gradientStartColor);
        gradient.addColorStop(1, gradientStopColor);
        var lineShouldDecay = lineDecayAfterPointIndex !== undefined;
        // Point color is all transparent, EXCEPT on lineDecayAfterPointIndex
        var pointBgColors = dataset.map(function (_, i) {
            return i === lineDecayAfterPointIndex
                ? pointBackgroundColor
                : "rgba(0, 0, 0, 0)";
        });
        var pointBorderColors = dataset.map(function (_, i) {
            return i === lineDecayAfterPointIndex
                ? decayedPointBorderColor
                : "rgba(0, 0, 0, 0)";
        });
        var sharedDatasetOptions = {
            type: "line",
            pointRadius: 6,
            pointHoverRadius: 6,
            pointBorderWidth: lineShouldDecay ? 8 : 1,
            pointHoverBorderWidth: lineShouldDecay ? 8 : 1,
            pointHitRadius: 20,
            pointBackgroundColor: pointBgColors,
            pointHoverBackgroundColor: lineShouldDecay
                ? pointBgColors
                : pointBackgroundColor,
            pointBorderColor: lineShouldDecay
                ? pointBorderColors
                : "rgba(0, 0, 0, 0)",
            pointHoverBorderColor: lineShouldDecay
                ? pointBorderColors
                : "rgba(0, 0, 0, 0)",
            tension: 0,
            fill: "start",
            backgroundColor: gradient,
            weight: 1,
            borderWidth: 2,
        };
        if (lineShouldDecay) {
            var datasetBeforeDecay = dataset.slice(0, lineDecayAfterPointIndex + 1);
            // Dataset after decay should match the same length of the entire dataset
            // but with the empty datapoints being `null`
            var datasetAfterDecay = dataset.slice(lineDecayAfterPointIndex, dataset.length);
            datasetAfterDecay = __spreadArray(__spreadArray([], Array.from({
                length: dataset.length - datasetAfterDecay.length,
            }).map(function () { return null; })), datasetAfterDecay);
            return {
                labels: labels,
                datasets: [
                    __assign(__assign({}, sharedDatasetOptions), { label: "dataset after decay", data: datasetAfterDecay, borderColor: decayedBorderColor }),
                    __assign(__assign({}, sharedDatasetOptions), { label: "dataset before decay", data: datasetBeforeDecay, borderColor: borderColor }),
                ],
            };
        }
        return {
            labels: labels,
            datasets: [
                __assign(__assign({}, sharedDatasetOptions), { data: dataset, borderColor: borderColor }),
            ],
        };
    }, [
        dataset,
        labels,
        borderColor,
        decayedBorderColor,
        decayedPointBorderColor,
        gradientStartColor,
        gradientStopColor,
        pointBackgroundColor,
        lineDecayAfterPointIndex,
    ]);
    return _jsx(Line, { type: "line", data: getData, options: options }, void 0);
};
export default PerformanceChart;
var templateObject_1, templateObject_2;
//# sourceMappingURL=PerformanceChart.js.map